import * as React from 'react';
import {useSelector} from 'react-redux';
import {Trans} from '@lingui/macro';

import FlatButton from '@components/FlatButton';
import CompletedIcon from '@components/Icons/CompletedIcon';

import s from './CompleteTestModal.module.css';

export default function CompleteTestModal({close, hasCompletedAllTests}) {
  const closeMessage = useSelector(state =>
    state.getIn(['userCampaign', 'data', 'onCompleteText'])
  );

  return (
    <>
      <div className={s.Container}>
        <div className={s.Header}>
          <div className={s.MailIcon}>
            <div className={s.Icon}>
              <CompletedIcon />
            </div>
            <div>
              <Trans id="calendar.complete_modal">Completato!</Trans>
            </div>
          </div>
        </div>

        <div className={s.Body}>
          {hasCompletedAllTests && closeMessage ? (
            <div dangerouslySetInnerHTML={{__html: closeMessage}}></div>
          ) : (
            <>
              <div className={s.Title}>
                {hasCompletedAllTests ? (
                  <Trans id="calendar.complete_tests_modal_title">
                    Complimenti! <br /> Hai completato tutte le attività della tua agenda!
                  </Trans>
                ) : (
                  <Trans id="calendar.complete_modal_title">
                    Complimenti! <br /> Hai completato l'attività.
                  </Trans>
                )}
              </div>
              <div className={s.Subtitle}>
                {!hasCompletedAllTests ? (
                  <Trans id="calendar.complete_modal_body" />
                ) : (
                  <Trans id="calendar.exit" />
                )}
              </div>
            </>
          )}
        </div>
      </div>

      {!hasCompletedAllTests && (
        <FlatButton className={s.Footer} onClick={close}>
          <Trans id="calendar.complete_modal_btn">Fine</Trans>
        </FlatButton>
      )}
    </>
  );
}
